/**
 * Configurazione dinamica Template Pagina Borgo — per slug comune.
 */

import { listEccellenze } from "./eccellenzeData";
import { getProdottiCertificatiBySlug } from "./borgoCertificazioneData";
import { MISSIONI_SEED } from "./generazioneMissioni";
import { SAGRA_PORCHETTA_ITALICA_URL } from "./economiaLocaleLinks";

const EMERGENZA_BASE = [
  { id: "112", label: "Numero Unico Europeo", valore: "112", tel: "112" },
  { id: "118", label: "Pronto Soccorso h24", valore: "118", tel: "118" },
  { id: "pc", label: "Sala Operativa Nazionale Protezione Civile", valore: "800 840 084", tel: "800840084" },
  { id: "115", label: "Vigili del Fuoco", valore: "115", tel: "115" },
  { id: "116117", label: "Continuità assistenziale / 116117", valore: "116 117", tel: "116117" },
];

/** Coordinate di riferimento (WGS84) per meteo */
const COORDS_BY_SLUG = {
  campli: { lat: 42.4042, lng: 13.7186 },
  "mosciano-sant-angelo": { lat: 42.7411, lng: 13.8878 },
  crognaleto: { lat: 42.5872, lng: 13.4889 },
  castelli: { lat: 42.4778, lng: 13.7124 },
  "castiglione-messer-raimondo": { lat: 42.503, lng: 13.943 },
  "civitella-del-tronto": { lat: 42.822, lng: 13.664 },
  pietracamela: { lat: 42.783, lng: 13.549 },
  montorio: { lat: 42.576, lng: 13.63 },
  teramo: { lat: 42.6589, lng: 13.7042 },
  giulianova: { lat: 42.7511, lng: 13.9439 },
  atri: { lat: 42.558, lng: 13.976 },
};

/** Voci vetrina locali (oltre eccellenze / certificati DB) */
const VETRINA_LOCALE = {
  campli: [
    { id: "loc-porchetta", nome: "Porchetta di Campli", tagline: "Maiale Nero d'Abruzzo · sigillo 6Amico", href: SAGRA_PORCHETTA_ITALICA_URL },
  ],
  atri: [
    { id: "loc-pan-ducale", nome: "Pan Ducale di Atri", tagline: "Guida enogastronomica · eccellenza storica", href: "/prodotti?comune=atri" },
    { id: "loc-becchetto", nome: "Becchetto e vini del Colle", tagline: "Cantine e botteghe del centro storico", href: "/vetrina?comune=atri" },
  ],
  crognaleto: [
    { id: "loc-tottea", nome: "Tottea · Nerito", tagline: "Patrimonio scultoreo della Laga", href: "/comune/crognaleto#tab-cosa-vedere" },
    { id: "loc-ebike", nome: "Percorsi E-Bike", tagline: "Rete sentieri certificati Gran Sasso", href: "/mappa-globale?mode=terra" },
  ],
  castelli: [
    { id: "loc-ceramica", nome: "Ceramica di Castelli", tagline: "Bottega istoriata · UNESCO candidatura", href: "/eccellenze/cert-ceramica-castelli" },
  ],
  "mosciano-sant-angelo": [
    { id: "loc-olio", nome: "EVO Aprutino", tagline: "Frantoio e oleifici del Fino", href: "/eccellenze/cert-olio-mosciano" },
  ],
  montorio: [
    { id: "loc-pizza-dolce", nome: "Pizza Dolce di Montorio", tagline: "Stratificazione · Varianti Familiari", href: "/eccellenze/ecc-pizza-dolce-montorio" },
    { id: "loc-bocconotti", nome: "Bocconotti di Montorio al Vomano", tagline: "Dolce a forma di calzone · tradizione del Vomano", href: "/prodotti?comune=montorio" },
  ],
};

const EMERGENZA_BY_SLUG = {
  crognaleto: [
    { id: "cai", label: "Soccorso Alpino · CAI Teramo", valore: "800 840 084", tel: "800840084", nota: "Coordinamento montagna · Protezione Civile Abruzzo" },
    { id: "guardia", label: "Guardia Medica montana", valore: "118", tel: "118", nota: "Emergenza sanitaria in quota" },
    ...EMERGENZA_BASE,
  ],
  pietracamela: [
    { id: "cai", label: "Soccorso Alpino · Gran Sasso", valore: "112", tel: "112", nota: "Per escursioni in alta quota" },
    ...EMERGENZA_BASE,
  ],
  atri: [
    { id: "guardia", label: "Guardia Medica Atri", valore: "116117", tel: "116117", nota: "Continuità assistenziale territorio" },
    ...EMERGENZA_BASE,
  ],
};

const MISSIONI_BY_SLUG = {
  crognaleto: ["mappa-sentieri", "monumento-storia", "capsula-piazza"],
  campli: ["monumento-storia", "ricetta-tradizione", "intervista-dialetto"],
  atri: ["ricetta-tradizione", "monumento-storia", "capsula-piazza"],
  montorio: ["ricetta-tradizione", "intervista-dialetto", "capsula-piazza"],
  castelli: ["monumento-storia", "ricetta-tradizione", "mappa-sentieri"],
};

const FEED_SEED = {
  campli: ["Nuova foto dalla Scala Santa in piazza · validata GPS", "Pro Loco: calendario sagre aggiornato"],
  crognaleto: ["Segnalazione sentiero Nerito · in attesa Custode", "Webcam Laga · condizioni sereno"],
  atri: ["Guida Pan Ducale · 12 Custodi hanno salvato nei preferiti", "Evento enogastronomico in centro storico"],
};

const AMBASCIATORE_BY_SLUG = {
  campli: "Custode · Rete Terre di Campli",
  crognaleto: "Custode · Comunità Montana Laga",
  atri: "Custode · Centro Storico Atri",
  montorio: "Custode · Valle del Vomano",
};

export function resolveBorgoCoords(comune) {
  const slug = comune?.slug;
  if (comune?.coordinates?.lat != null && comune?.coordinates?.lng != null) {
    return { lat: comune.coordinates.lat, lng: comune.coordinates.lng };
  }
  return COORDS_BY_SLUG[slug] || { lat: 42.65, lng: 13.7 };
}

export function getEmergenzaServizi(slug) {
  return EMERGENZA_BY_SLUG[slug] || EMERGENZA_BASE;
}

export function getVetrinaEccellenze(slug) {
  const items = [];
  const seen = new Set();

  function push(item) {
    if (!item?.nome || seen.has(item.id)) return;
    seen.add(item.id);
    items.push(item);
  }

  listEccellenze({ borgoSlug: slug }).forEach((e) => {
    push({
      id: e.id,
      nome: e.nome,
      tagline: e.categoria,
      href: `/eccellenze/${e.id}`,
      imageUrl: e.imageUrl,
    });
  });

  getProdottiCertificatiBySlug(slug).forEach((p) => {
    push({
      id: p.id,
      nome: p.nome,
      tagline: p.categoria,
      href: p.eCommerceDiretto || `/prodotti?comune=${slug}`,
      imageUrl: p.fotoProdotto,
    });
  });

  (VETRINA_LOCALE[slug] || []).forEach(push);

  if (items.length === 0) {
    push({
      id: "vetrina-network",
      nome: "Eccellenze del territorio",
      tagline: "Catalogo in espansione · Protocollo 6Amico",
      href: "/eccellenze",
    });
  }

  return items.slice(0, 6);
}

export function getMissioniBorgo(slug) {
  const ids = MISSIONI_BY_SLUG[slug] || ["capsula-piazza", "monumento-storia", "ricetta-tradizione"];
  return MISSIONI_SEED.filter((m) => ids.includes(m.id)).slice(0, 3);
}

export function getFeedAttivitaSeed(slug, comuneName) {
  const custom = FEED_SEED[slug];
  if (custom?.length) return custom;
  return [
    `Attività recenti su ${comuneName || "borgo"} · Piazza Social`,
    "Missioni territoriali aperte agli Agenti 6Amico",
    "Patrimonio gastronomico in validazione Custode",
  ];
}

export function getAmbasciatoreLabel(slug) {
  return AMBASCIATORE_BY_SLUG[slug] || "Custode del borgo · 6amico";
}

/**
 * Override per-slug applicati dopo defaults e record API (vedi buildComunePageConfig.js).
 */
export function getSlugTemplateOverrides(slug) {
  if (!slug) return {};
  const out = {};
  if (AMBASCIATORE_BY_SLUG[slug]) out.ambasciatore = AMBASCIATORE_BY_SLUG[slug];
  if (EMERGENZA_BY_SLUG[slug]) out.emergenza = EMERGENZA_BY_SLUG[slug];
  if (MISSIONI_BY_SLUG[slug]) {
    out.missioni = getMissioniBorgo(slug);
  }
  if (FEED_SEED[slug]) out.feedSeed = FEED_SEED[slug];
  if (VETRINA_LOCALE[slug]?.length) {
    out.vetrina = getVetrinaEccellenze(slug);
  }
  return out;
}

